import request from '@/utils/request'

function unwrap(response) {
  const result = response.data
  if (result && result.code === 0) {
    return result
  }
  throw new Error((result && result.msg) || '车道控制服务请求失败')
}

export function listParking99Channels() {
  return request({
    url: '/parking99.listChannels',
    method: 'get',
    params: {}
  }).then(unwrap)
}

export function refreshParking99Channels(data) {
  return request({
    url: '/parking99.refreshChannels',
    method: 'post',
    data
  }).then(unwrap)
}

export function operateParking99Gate(data) {
  return request({
    url: '/parking99.operateGate',
    method: 'post',
    data
  }).then(unwrap)
}

export function generateParking99ExitPayCode(data) {
  return request({
    url: '/parking99.generateExitPayCode',
    method: 'post',
    data
  }).then(unwrap)
}

export function downloadParking99ExitPayCode(data) {
  return request({
    url: '/parking99.downloadExitPayCode',
    method: 'post',
    data
  }).then(unwrap)
}
